import { useDepartureTimesFilter } from '../../helpers/hooks/useDepartureTimesFilter';

import { DepartureTimesFilterView } from './DepartureTimesFilterView';

export const DepartureTimesFilter = () => {
  const { onChange, selectedTimes } = useDepartureTimesFilter();

  return (
    <DepartureTimesFilterView
      selectedTimes={selectedTimes}
      onChange={onChange}
    />
  );
};
